<template>
  <div class="autocomplete">
    <input
      type="text"
      :value="query"
      @input="onInput"
      :placeholder="placeholder"
      class="autocomplete-input"
    />
    <ul v-if="suggestions.length && query" class="autocomplete-suggestions">
      <li
        v-for="(item, index) in suggestions"
        :key="index"
        @click="select(item)"
        class="autocomplete-suggestion"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { getUsers } from '@/api/users'

const props = defineProps({
  modelValue: {
    type: [String, Object],
    default: '',
  },
  placeholder: {
    type: String,
    default: 'Начните вводить...',
  },
  paramName: {
    type: String,
    default: 'name',
  },
  params: {
    type: Object,
    default: () => ({}),
  },
})

const emit = defineEmits(['update:modelValue', 'select'])

const query = ref('')
const suggestions = ref([])
let debounceTimeout = null

function onInput(event) {
  query.value = event.target.value
  emit('update:modelValue', query.value)

  clearTimeout(debounceTimeout)
  debounceTimeout = setTimeout(() => {
    if (query.value?.length < 2) {
      suggestions.value = []
      return
    }

    const params = { ...props.params }
    params[props.paramName] = query.value

    getUsers(params)
      .then((data) => {
        suggestions.value = data.users || []
      })
      .catch((error) => {
        console.error('Error fetching suggestions:', error)
        suggestions.value = []
      })
  }, 300)
}

function select(item) {
  query.value = item.name
  emit('update:modelValue', item)
  emit('select', item)
  suggestions.value = []
}

watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue !== undefined) {
      const displayValue =
        typeof newValue === 'object' && newValue?.name
          ? newValue.name
          : newValue
      if (displayValue !== query.value) {
        query.value = displayValue
      }
    }
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
.autocomplete {
  position: relative;
  width: 100%;

  &-suggestions {
    border: 1px solid #d2d2d2;
    margin: 0;
    padding: 0;
    list-style: none;
    position: absolute;
    background: white;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    z-index: 10;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  &-suggestion {
    padding: 10px 12px;
    cursor: pointer;

    &:hover {
      background: #f5f5f5;
    }
  }
}
</style>
